export enum PatientDataTitle {
  ACTION = "",
  ADDRESS = "ADDRESS",
  CITY = "CITY",
  DOB = "DOB",
  ELIGIBILITY_DATE = "ELIGIBILITY DATES",
  MBI = "MBI",
  NAME = "NAME",
  STATE = "STATE",
  SUBSCRIBER_ID = "SUBSCRIBER ID",
}

export const PatientHeaderLabel = [
  { label: PatientDataTitle.NAME, width: 260 },
  { label: PatientDataTitle.DOB, width: 100 },
  { label: PatientDataTitle.SUBSCRIBER_ID, width: 130 },
  { label: PatientDataTitle.MBI, width: 70 },
  { label: PatientDataTitle.ELIGIBILITY_DATE, width: 230 },
  { label: PatientDataTitle.ADDRESS, width: 250 },
  { label: PatientDataTitle.CITY, width: 120 },
  { label: PatientDataTitle.STATE, width: 70 },
  { label: PatientDataTitle.ACTION, width: 90 },
];

export enum PatientRecordDispatchTypes {
  POST_PATIENT_RECORD_ERROR = "POST_PATIENT_RECORD_ERROR",
  POST_PATIENT_RECORD_INVOKE = "POST_PATIENT_RECORD_INVOKE",
  POST_PATIENT_RECORD_SUCCESS = "POST_PATIENT_RECORD_SUCCESS",
  POST_PATIENT_RECORD_RESET = "POST_PATIENT_RECORD_RESET",
}

export enum AuthorizationHistoryDispatchTypes {
  GET_AUTH_HISTORY_ERROR = "GET_AUTH_HISTORY_ERROR",
  GET_AUTH_HISTORY_INVOKE = "GET_AUTH_HISTORY_INVOKE",
  GET_AUTH_HISTORY_SUCCESS = "GET_AUTH_HISTORY_SUCCESS",
}

export enum HeaderTitles {
  WELCOME_TO_THE_HEALTH_PLAN_ACCESS_PORTAL = "Welcome to the Health Plan Access Portal",
  SEARCH_TITLE = "Search must include at least two of the options below to meet the search criteria.",
  TANGO_SECURE_PORTAL_TITLE = "The tango secure portal allows the user to view and track a member's home health journey. Users can check the status of current requests, authorization of services and stay informed about health plan member."
}

export enum MessageType { 
  UPDATE_REFERRAL_DATA = "UPDATE_REFERRAL_DATA",
  DOCUMENT_DOWNLOAD_ERROR = "DOCUMENT_DOWNLOAD_ERROR",
}
const referralMessageMap: Record<string, string> = {
  [MessageType.UPDATE_REFERRAL_DATA]: "Referral Details Updated Successfully !",
  [MessageType.DOCUMENT_DOWNLOAD_ERROR]: "Document Download Error!",
}
export const ReferralResponseMessages = (value: string): string =>
  referralMessageMap[value] || "";

export const SearchPayloadRecord = {
  lastName: "",
  subscriberId: "",
  dateOfBirth: "",
}